/**
 * Kiosk (點餐機式下單) 設計 token。
 * 對齊 proto5.html 的 :root 色票，與現有 @styles/colors 並存——
 * 這條新流程自成一套視覺，不沿用 GasShop 的 Tamagui 預設樣式。
 */
export const kiosk = {
  blue: "#2196f3",
  blueD: "#1e88e5",
  blueL: "#4fb0f7",
  ink: "#0f1a35",
  grey: "#6b7280",
  line: "#eceff5",
  bg: "#fafbff",
  card: "#fff",
  green: "#16a34a",
  amber: "#9a6a2c",
  amberStrong: "#c2410c",
  amberBg: "#fff7ed",
  amberBorder: "#fde2c4",
  danger: "#cc2255",
  /** 主漸層（135deg）——用 className kiosk-grad / kiosk-grad-soft 套用，token 供 JS 計算用 */
  gradPrimary: "linear-gradient(to bottom,#2196f3,#1e88e5)",
  gradPage: "linear-gradient(180deg,#fafbff 0%,#eef3ff 100%)",
  pillBg: "#eef4ff",
  softCardFrom: "#f0f5ff",
  softCardTo: "#dde8ff",
  softCardBorder: "#c8dbff",
} as const;

export const PRESET_USAGE_LOCATIONS = ["瓦斯爐", "熱水器", "烘衣機"] as const;

/** 使用位置 → icon name（KioskIcon） */
export const USAGE_ICON: Record<string, string> = {
  瓦斯爐: "flame",
  熱水器: "shower",
  烘衣機: "dryer",
  暖氣: "heater",
  壁爐: "fireplace",
};

/** 將 form floor 字串轉成 BE int。B1 → -1、1F → 1、6F+ 自訂（"B2" → -2、"7"/"7F" → 7）。 */
// 樓層解析統一由共用 util 處理（支援全形正規化）；保留此處 re-export 不動既有 import 路徑。
export { parseFloorToInt } from "@utils/func/floor";

/** BE floor int → 顯示文字（B1 / 1F / 12F）。 */
export function floorIntToLabel(floorInt: number): string {
  if (floorInt === 0) return "1F";
  return floorInt > 0 ? `${floorInt}F` : `B${-floorInt}`;
}

/** BE floor int → picker 選項（命中 B1/1F~5F 即直選，否則走 6F+ 自訂）。 */
export function floorIntToPicker(floorInt: number): { floorSel: string; floorOther: string } {
  if (floorInt === -1) return { floorSel: "B1", floorOther: "" };
  if (floorInt >= 1 && floorInt <= 5) return { floorSel: `${floorInt}F`, floorOther: "" };
  if (floorInt === 0) return { floorSel: "1F", floorOther: "" };
  return { floorSel: "6F+", floorOther: floorInt < 0 ? `B${-floorInt}` : `${floorInt}` };
}

/** 使用位置字串 → picker（命中 preset 即原值，否則「其他」+ 自訂）。 */
export function usageToPicker(loc: string): { useSel: string; useOther: string } {
  if ((PRESET_USAGE_LOCATIONS as readonly string[]).includes(loc)) return { useSel: loc, useOther: "" };
  return { useSel: "其他", useOther: loc };
}
